import { render, staticRenderFns } from "./Bräuer.vue?vue&type=template&id=70a25852&scoped=true&"
var script = {}
import style0 from "./Bräuer.vue?vue&type=style&index=0&id=70a25852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a25852",
  null
  
)

export default component.exports